function __formatString(this: string, args: { [key: string]: any }): string {
  let result: string = this || '';
  for (const propertyName in args) {
    if (args.hasOwnProperty(propertyName)) {
      let propertyValue = args[propertyName];
      if (propertyValue === undefined) {
        propertyValue = '[undefined]';
      }
      else if (propertyValue === null) {
        propertyValue = '[null]';
      }
      result = result.replace(`{${propertyName}}`, propertyValue);
    }
  }
  return result;
}
function __encodeString(stringToEncode: string) {
  return  stringToEncode.replace(new RegExp('&', 'g'), '&amp;')
                  .replace(new RegExp('<', 'g'), '&lt;')
                  .replace(new RegExp('>', 'g'), '&gt;')
                  .replace(new RegExp('"', 'g'), '&quot;');
}

function __decodeString(stringToDecode: string) {
  return stringToDecode.replace(new RegExp('&amp;', 'g'), '&');
}

function __forConfiguration(this: string): string {
  if (this) {
    return this.replace(' ', '').toLowerCase();
  }
  return undefined;
}

export { __formatString, __encodeString, __decodeString, __forConfiguration };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/helper/string-extensions/extensions.ts